module.exports = __webpack_public_path__ + "static/media/commissions5.328a61ed.png";